export default __webpack_public_path__ + "images/7342f65db5b9bb9b02700ef08b4ef27c.png";